export interface GridSizeConfig {
  minTdDefaultWidth?: string;
  minStatusTdDefaultWidth?: string;
  minTdDateWidth?: string;
  minTdActionsWidth?: string;
}
